import "../styles/browser.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "./Langs";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";
import axios from "axios";
import { getUrl, getApiUrl } from "./urlHook";
const apiUrl = getApiUrl();

document.documentElement.style.overflow = "hidden";

const ViewDocument = (props) => {
  const navigate = useNavigate();
  const eid = document.location.pathname.split("/").slice(-1)[0];
  const [openHelp, setOpenHelp] = useState(false);
  const logo = GetLogo();
  const [lang, setLang] = useLanguage();
  const [pdf, setPdf] = useState("");

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${apiUrl}/pdf`, {
        eid: eid,
      });

      if (response) {
        console.log(response.data);
        setPdf(response.data);
      }
    })();
  }, []);

  if (pdf === "") {
    return (
      <div>
        <img
          src="../Spinner-0.7s-200px (1).svg"
          alt="loading please wait."
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            maxWidth: "500px",
            width: "500px",
            transform: "translate(-50%, -50%)",
          }}
        ></img>
      </div>
    );
  }

  return (
    <div id="view" className="noOverFlow">
      <Navbar
        id="navbar"
        lang={[lang, setLang]}
        disableToolBar
        setOpenHelp={setOpenHelp}
        openHelp={openHelp}
        color={logo.color}
        banner={logo.banner}
        helpColor={logo.helpColor}
      ></Navbar>
      <iframe
        src={`data:application/pdf;base64,${pdf}`}
        className="pdf"
        type="application/pdf"
      ></iframe>
    </div>
  );
};

export default ViewDocument;
